import React, { useEffect, useState } from 'react';
import { Box, LinearProgress } from '@mui/material';
import { getColors } from '../../../theme';

const colors = getColors();
export default function ProgressBar({ duration, close }) {
  const [progress, setProgress] = useState(100);
  const { colorShades } = colors;

  useEffect(() => {
    const decrement = 100 / (duration / 100);
    const interval = setInterval(() => {
      setProgress((prev) => (prev <= 0 ? 0 : prev - decrement));
    }, 100);

    return () => clearInterval(interval);
  }, [duration]);

  useEffect(() => {
    if (!progress) close();
  }, [progress]);

  return (
    <Box sx={{ width: '100%', position: 'absolute', left: 0, bottom: 0 }}>
      <LinearProgress
        sx={{
          background: 'transparent',
          '& .MuiLinearProgress-barColorPrimary': { backgroundColor: colorShades.pureWhite },
        }}
        variant="determinate"
        value={progress}
      />
    </Box>
  );
}
